import { UserSelectT } from './user-select.types';

export const mapUserSelectOptions = (user: UserSelectT) => {
  const { id, firstName, lastName, photoThumbUrl, hasAvatar, initials } = user;
  return {
    value: id,
    label: `${firstName} ${lastName}`,
    photoThumbUrl,
    hasAvatar,
    initials,
  };
};
